import React from 'react';
import styles from './TopBar1.module.css';
import { FaFacebookF, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TopBar1 = ({ branding }) => {
  const { user } = useAuth();

  const phone =
  branding?.phones?.join(" | ") ||
  user?.companyPhone ||
  "+91 0000000000";

  const email =
    branding?.email ||
    user?.companyEmail ||
    "contact@travel.com";

  const facebookUrl =
    branding?.socials?.facebook || "#";

  const instagramUrl =
    branding?.socials?.instagram || "#";

  const twitterUrl =
    branding?.socials?.x || "#";

  return (
    <div className={styles.topBar}>
      <div className={styles.container}>

        {/* Left Side: Social Icons */}
        <div className={styles.socialIcons}>
          <a href={facebookUrl} target="_blank" rel="noreferrer" className={styles.iconLink}>
            <FaFacebookF />
          </a>
          <a href={instagramUrl} target="_blank" rel="noreferrer" className={styles.iconLink}>
            <FaInstagram />
          </a>
          <a href={twitterUrl} target="_blank" rel="noreferrer" className={styles.iconLink}>
            <FaTwitter />
          </a>
        </div>

        {/* Right Side: Contact Info */}
        <div className={styles.contactInfo}>
          <div className={styles.contactItem}>
            <FaPhoneAlt className={styles.icon} />
            <span>{phone}</span>
          </div>

          <div className={styles.contactItem}>
            <FaEnvelope className={styles.icon} />
            <span>{email}</span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default TopBar1;